<script>
import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
import templatable from "@/mixins/templatable";
import LotListAndFilters from "@/components/LotListAndFilters";
import {LOT_LIST_DEFAULT_LIMIT, LOT_LIST_DEFAULT_PAGE} from "@/constants";
import {updateLotsRoute} from "@/helpers";
import MyBidsShortList from "@/components/configuration/home/MyBidsShortList.vue";
import FavouriteLotsShortList from "@/components/configuration/home/FavouriteLotsShortList.vue";

export default {
  name: "Lots",
  components: {
    LotListAndFilters, MyBidsShortList, FavouriteLotsShortList
  },
  mixins: [templatable('lotListTemplate')],
  props: {
    auctionUuid: {
      type: String,
      default: null
    }
  },
  data: () => ({
    template: `
        [[template]]
    `
  }),
  watch: {
    '$route.query': {
      // immediate: true,
      handler() {
        this.updateData()
      },
    },
  },
  computed: {
    ...mapState(['lotListViewType', 'lotQueryParams', 'departments', 'categories']),
    ...mapGetters(['lotStatuses', 'lots']),
    selectedDepartment() {
      const [key] = this.lotQueryParams.department || [];

      return (this.departments?.data || []).find(d => d.key === key);
    }
  },
  methods: {
    ...mapActions(['getLots', 'getDepartments']),
    ...mapMutations(['setLotFilters', 'emptyLotFilters', 'emptyLots']),
    updateFilters(filters){
      filters.page = LOT_LIST_DEFAULT_PAGE;
      this.setLotFilters(filters)
      updateLotsRoute()
    },
    updateData() {
      this.emptyLotFilters();
      this.setLotFilters({
        ...this.$route.query,
        auction_uuid: this.auctionUuid,
      });
      this.getLots();
      this.getDepartments();
    }
  },
  mounted() {
    this.updateData()
  },
  beforeDestroy() {
    this.emptyLots();
  },
  destroyed() {
    this.emptyLotFilters();
    this.setLotFilters({
      page: LOT_LIST_DEFAULT_PAGE,
      limit: LOT_LIST_DEFAULT_LIMIT
    });
  }
}
</script>
